<!-- Tab.vue -->
<template>
  <div class="tab-pane" v-if="isSelected">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabPane',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // 使用数据属性而不是计算属性来存储是否被选中的状态
      isSelected: false
    };
  },
};
</script>

<style scoped>
</style>